"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CATEGORY_GROUPS_REDUCER_KEY = exports.categoryGroupReducerChain = void 0;
const redux_actions_1 = require("redux-actions");
const core_1 = require("companion-app-components/utils/core");
const core_2 = require("companion-app-components/flux/core");
const category_groups_1 = require("companion-app-components/flux/category-groups");
const actions = __importStar(require("./categoryGroupsActions"));
const log = (0, core_1.getLogger)('data/categoryGroups/categoryGroupsReducer.js');
const categoryGroupsStoreFactory = core_2.resourceStoreTypes.createTypedQcsSyncResourceStoreFactory();
const categoryGroupsReducer = (0, redux_actions_1.handleActions)({
    [actions.createCategoryGroupsAction.type]: (state) => {
        log.log('createCategoryGroupsAction...');
        return state.merge({ isLoading: true });
    },
    [actions.createCategoryGroupsSuccessAction.type]: (state, { payload }) => {
        log.log('createCategoryGroupsSuccessAction...\n', payload);
        return core_2.resourceUpserters.upsertResources(state, payload);
    },
    [actions.createCategoryGroupsFailureAction.type]: (state, { payload: error }) => core_2.resourceUpserters.completeWithError(state, error),
}, categoryGroupsStoreFactory());
// chain reducers
const categoryGroupReducerChain = (state, action) => ((0, category_groups_1.categoryGroupsReducer)(categoryGroupsReducer(state, action), action));
exports.categoryGroupReducerChain = categoryGroupReducerChain;
exports.CATEGORY_GROUPS_REDUCER_KEY = category_groups_1.CATEGORY_GROUPS_REDUCER_KEY;
exports.default = exports.categoryGroupReducerChain;
